import {
  useGetVacancyByIdPublicApiV1VacanciesPublicVacancyIdOrAliasGet,
  getGetVacancyByIdPublicApiV1VacanciesPublicVacancyIdOrAliasGetQueryKey
} from 'api/endpoints/openapi-generated'
import {
  UseQueryResult,
  QueryCacheNotifyEvent,
  QueryKey
} from '@tanstack/react-query'
import {
  GetVacancyResponse,
  HTTPValidationError
} from 'api/endpoints/openapi-generated.schemas'
import { queryClient } from 'query-client'
import { type ApiError } from 'api/mutator/platform-instance'

type VacancyQueryData = GetVacancyResponse

export function getVacancyDataFromEvent(
  event: QueryCacheNotifyEvent,
  vacancyId: string
): VacancyQueryData | null | undefined {
  if (event.type !== 'updated') return

  const queryKey = getVacancyQueryKey(vacancyId)
  if (event.query.queryKey.toString() !== queryKey.toString()) return

  const data = event.query.state.data as VacancyQueryData | undefined
  return data ?? null
}

function getVacancyQueryKey(vacancyId: string): QueryKey {
  return getGetVacancyByIdPublicApiV1VacanciesPublicVacancyIdOrAliasGetQueryKey(
    vacancyId
  )
}

export function getVacancy(
  vacancyId: string
): VacancyQueryData['data'] | undefined {
  const queryData = queryClient.getQueryData<VacancyQueryData>(
    getVacancyQueryKey(vacancyId)
  )

  return queryData?.data
}

export function useVacancy(
  vacancyId: string
): UseQueryResult<
  VacancyQueryData | undefined,
  ApiError<HTTPValidationError> | null
> {
  const queryKey = getVacancyQueryKey(vacancyId)

  const result = useGetVacancyByIdPublicApiV1VacanciesPublicVacancyIdOrAliasGet<
    VacancyQueryData,
    ApiError<HTTPValidationError> | null
  >(vacancyId, {
    query: {
      queryKey,
      retry: (failureCount, error) => {
        if (error?.status === 403) return false
        return failureCount < 2
      }
    }
  })

  return result
}
